export default __webpack_public_path__ + "static/media/HTLIFE_logo.4f873290.png";